import React from 'react';
const intl = {
  headline: {
    'en': 'METHODOLOGY',
    'dk': 'METODE',
  },
  block1: {
    headline: {
      'en': 'WHAT WE DO',
      'dk': 'HVAD VI GØR',
    },
    subHeadline: {
      'en': <div>Our approach is scientifically informed and based on an<br/> extensive experience base</div>,
      'dk': <div>Vores tilgang er erfaringsbaseret og videnskabeligt forankret </div>
    },
    body: {
      'en': <div>
        We challenge assumptions, preconceptions and biases. We collect and analyze data and make recommendations that can help organizations achieve success. Throughout, we draw on our collective expertise in organizational dynamics.
        <br/><br/>
        We work methodically and systemic making use of facilitated processes. No matter the scope or scale of the project –strategy development and implementation, group collaboration, performance issues – we address what is on the surface and what lies beneath it too.
        <br/><br/>
        Our approach is based on three solid pillars; a strong experience base, scientifically based methods and research and finally organizational diagnostics.
      </div>,
      'dk': <div>
        Vi udfordrer antagelser, forudindtagede holdninger og for-forståelser. Vi samler og analyserer data og anbefaler handlinger, der alle har ét sigte: at forbedre organisationens evne til at levere resultater. Hele vejen igennem trækker vi på vores kollektive ekspertise og forståelse af organisationens dynamikker.
        <br/><br/>
        Vi arbejder metodisk og systemisk gennem brug af faciliterende processer. Uanset størrelse eller omfang af et projekt; det være sig strategi udvikling, implementering af forandringer, gruppesamarbejde eller præstationsudvikling - vi adresserer det der er tilstede samt det, der er under overfladen.
        <br/><br/>
        Vores tilgang bygger på tre solide elementer; en stærk erfaringsbaseret viden, videnskabelige metoder og forskning samt organisations diagnostik.
      </div>
    }
  },
  goToTestButton: {
    'en': 'GO TO TEST',
    'dk': 'GÅ TIL TEST',
  },
  divider1: {
    'en': '',
    'dk': ''
  },
  block2: {
    headline: {
      'en': 'LEADERSHIP EVALUATION TOOL',
      'dk': 'LEADERSKABS EVALUERINGS VÆRKTØJ',
    },
    body: {
      'en': <div>
        Leadership depends upon a wide range of dynamic relationships. In order to address them, a leader needs to be empathetic, present and focused.
        <br /><br />
        A results-oriented leader is one willing to take responsibility, motivate and inspire people. One who will stretch their colleagues but also give responsibility back to those who make change happen.
        <br /><br />
        Our Leadership Evaluation Tool helps you build awareness of how you lead. It examines key areas defined by 12 parameters. The findings are enhanced by input from three of the people you lead or have a professional work relation with.
        <br /><br />
        The use of Johari's window identifies what we know about ourselves and what we are blind to. Leadership Evaluation highlights the differences between how we perceive ourselves and how others experience us. The insights gained enable leaders to have more meaningful conversation with colleagues.
        <br /><br />
        Try it and let us know what you think. It's completely free of charge but not necessarily without personal cost. You might learn something important about yourself and your relationships. Enjoy.
      </div>,
      'dk': <div>
        Ledelse er karakteriseret af en lang række forhold. Forhold der hverken er eksklusive eller endegyldige i deres definition. De er kun indikerende for omfanget af lederens evne til at være empatisk, nærværende og fokuseret.
        <br /><br />
        Fokus bør være på skabelsen af resultater – en skabelse der afhænger af lederens evne til både at tage ansvar, motivere og inspirere mennesker; men også at stille krav og give noget af det ansvar fra sig.
        <br /><br />
        En selvevaluering er et værktøj, der giver dig mulighed for at vurdere dine leder evner defineret ved 12 parametre samlet under 3 overskrifter – og samtidig invitere tre andre til at give dig deres oplevelse af dig som leder.
        <br /><br />
        Johari‘s vindue beskriver blandt andet områder af os selv vi kender og områder vi er blinde for. Selvevalueringen åbner op for en beskrivelse af netop den forskel; hvordan vi oplever os selv – og hvordan andre oplever os. Resultatet giver os en mulighed for at indgå i en mere kvalificeret og målrettet dialog med kollegaer, medarbejdere eller ledere om hvad det er de ser.
        <br /><br />
        Prøv det og lad os høre hvad du synes. Det er gratis – men ikke nødvendigvis omkostningsfrit; du kunne blive rigere på vigtig viden om dig selv og dine relationer. God fornøjelse.
      </div>,
    },
  },
  block3: {
    headline1: {
      'en': 'CULTURE',
      'dk': 'KULTUR',
    },
    subheadline1: {
      'en': 'What is it and why is it so important?',
      'dk': 'Hvad er det og hvorfor er det så vigtigt?',
    },
    body1: {
      'en': 'We believe that with culture being so important and crucial in an organizations ability to perform it needs much more attention. It requires a continuous and conscious effort to develop a healthy well-functioning culture that support and enhance performance.',
      'dk': '',
    },
    headline2: {
      'en': 'COMMUNICATION',
      'dk': 'KOMMUNIKATION',
    },
    subheadline2: {
      'en': 'Build relations for collaborative results',
      'dk': 'Bygge relationer for fællers resultater',
    },
    body2: {
      'en': 'Communication has so many forms – especially with the explosion in digital formats. It is verbal and non-verbal. It tacit and implicit. It‘s obvious and hidden. Its conscious and subconscious or even unconscious. Whatever form it takes it creates and maintains relations between organizational members. In other words – its crucial to get right.',
      'dk': '',
    },
    headline3: {
      'en': 'CHANGE',
      'dk': 'FORANDRING',
    },
    subheadline3: {
      'en': 'Unavoidable and challenging. Why is it so hard?',
      'dk': 'Uundgåeligt og udfordrende. Hvorfor er det så svært?',
    },
    body3: {
      'en': 'We believe that with the right approach you can actually accelerate your change process – AND – get a better implementation result. It’s a myth that only 30% of change initiatives succeed.  iLEAD  have done some ground breaking research that allows for better and faster implementions.',
      'dk': '',
    }
  },
  block4: {
    headline: {
      'en': <span>THE PIVOTAL POINT OF IT ALL - <b>LEADERSHIP</b></span>,
      'dk': '',
    },
    body: {
      'en': <div>
        <span style={{ color: '#1abc9c' }}>Executive coaching</span> Our approach to coaching is informed by the recognition that early developed patterns in behavior and our tendency to repeat behavior can trip us up. It‘s not only the behavior that works but also the ones that don’t we tend to repeat. Increased awareness and understanding enable leaders to change themselves or supplement their leadership team with the necessary complementary skills.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Supervision of leadership groups.</span> These groups usually consist of strong independent individuals that need to work together while having a high degree of autonomy in their own resort. These circumstances represent a multiple of potential strains within the system and opposed interests, which might cause unnecessary conflicts and tension.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Cultural advisory to Management / Board</span>We help management and/or board in the role of cultural alignment advisors or even CCO (chief cultural officer) on a interim basis. It ensures the leadership team to have someone that actually focuses and address this crucial area especially in the volatile period of change.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Interim Solutions</span>We do also engage in interim assignments taking on the responsibility of leadership for a limited period of time. Terms and conditions are to be negotiated individually and customized to the organizations needs.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Leadership development programs</span>Finally we offer bespoke leadership programs tailored to meet the organizational needs at any specific point in time with a clear view of future directions and goals. We work with a number of suppliers all over the world to ensure an suitable environment and conducive atmosphere for specifics goals.
      </div>,
      'dk': '',
    }
  },
  block5: {
    subheadline: {
      'en': 'LIFE IS ABOUT OPPORTUNITIES',
      'dk': 'LIVET HANDLER OM MULIGHEDER'
    },
    headline: {
      'en': <span>The opportunities around us are infinite. If only we dare to look for them, and have courage to do what it takes, whether it's change of direction, structure or event strategy. <br/><br/>
      Well, sometimes it's just ourselves we need to change!</span>,
      'dk': <span>Mulighederne omkring os er uendelige. Hvis vi tør kigge op og har modet til gøre det, der kræves. Uanset om det er at ændre retning, struktur – eller strategi! <br/><br/> og nogle gange er det 'bare' os selv der skal turde forandring!</span>
    }
  }
}

export default intl;



// WEBPACK FOOTER //
// ./src/pages/Methodology/intl.js